<script>
  import _ from 'lodash';
  import VirtualList from '@sveltejs/svelte-virtual-list';

  import emojis from 'emoji.json/emoji.json';
  import Emoji from "./Emoji.svelte";
  import {onMount} from 'svelte';

  export let channel;
  export let onSelectEmoji;

  // const chunkedEmojis = _.orderBy(_.chunk(_.uniqBy(emojis, e => e.codes.split(' ')[0]), 12), 'group');
  // const chunkedEmojis = _.chunk(emojis, 12);

  // console.log(_.uniq(_.map(emojis, 'group')))

  // use 'groups' for ordering
  const groups = ["Smileys & Emotion", "People & Body", "Animals & Nature", "Food & Drink", "Travel & Places", "Activities", "Objects", "Symbols", "Flags"];
  const groupOrderMap = {};
  for (let i = 0; i < _.size(groups); i++) {
    groupOrderMap[groups[i]] = i;
  }

  const chunkSize = window.innerWidth > 600 ? 12 : 6;

  let searchInput;
  let keyword = '';

  const getEmojiData = (emojis, keyword) => {
    const orderedEmojis = _.orderBy(_.uniqBy(_.filter(emojis, e => {
      if (!keyword) return true;

      const target = (e.category + ' ' + e.name).toLowerCase();

      return target.includes(keyword.toLowerCase());

    }), e => e.codes.split(' ')[0]), e => groupOrderMap[e.group]);
    const emojisByGroup = _.mapValues(_.groupBy(orderedEmojis, 'group'), emojis => {
      return _.chunk([{...emojis[0], displayGroup: true}, ..._.tail(emojis)], chunkSize);
    });

    const emojiData = [];
    _.forEach(_.filter(groups, group => !!emojisByGroup[group]), group => emojiData.push(...emojisByGroup[group]));

    return emojiData;
  };

  onMount(() => {
    searchInput && searchInput.focus();
  });
</script>

<column style="height: 100%;">
  <row align-center class="search-form">
    <ion-icon name="search-outline"></ion-icon>
    <input type="text" placeholder="Search" bind:value={keyword} bind:this={searchInput}>
  </row>
  <VirtualList items={getEmojiData(emojis, keyword)} let:item>
      {#if _.first(item).displayGroup}
        <div class="group-header">{_.first(item).group}</div>
      {/if}
    <row>
        {#each _.range(chunkSize) as i}
          <flex class="emoji center clickable" on:click={item[i] ? () => onSelectEmoji(item[i]) : null}>
              {#if item[i]}
                <Emoji emoji={item[i]}/>
              {/if}
          </flex>
        {/each}
    </row>
  </VirtualList>
</column>


<style>
  .search-form {
    height: 48px;
    padding: 0 12px;
  }

  .search-form ion-icon {
    font-size: 20px;
    margin-right: 8px;
  }

  input {
    border: none;
    height: 32px;
    flex: 1;
    font-size: 1.1rem;
  }

  .group-header {
    margin: 8px 12px;
    color: #aaa;
  }

  .emoji {
    font-size: 32px;
    height: 40px;
    flex: 1;
  }
</style>